import React from 'react';
import { Link } from 'react-router-dom';

export default function LogoMark({ style }) {
  return (
    <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', textDecoration: 'none', ...style }}>
      <span style={{
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        width: '28px', height: '28px', borderRadius: '7px',
        background: 'linear-gradient(135deg, #38bdf8 0%, #a78bfa 100%)',
        boxShadow: '0 0 12px rgba(56,189,248,0.4), 0 2px 6px rgba(167,139,250,0.25)',
        flexShrink: 0,
      }}>
        <svg width="16" height="20" viewBox="0 0 40 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 3C12.268 3 6 9.268 6 17c0 4.8 2.4 9.05 6 11.6V33a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-4.4c3.6-2.55 6-6.8 6-11.6C34 9.268 27.732 3 20 3Z" fill="white" opacity="0.95"/>
          <rect x="13" y="37" width="14" height="3" rx="1.5" fill="white" opacity="0.85"/>
          <rect x="14.5" y="42" width="11" height="3" rx="1.5" fill="white" opacity="0.7"/>
          <ellipse cx="15" cy="13" rx="3" ry="5" fill="white" opacity="0.25" transform="rotate(-15 15 13)"/>
        </svg>
      </span>
      <span style={{
        fontSize: '20px', fontWeight: '900', letterSpacing: '-0.5px',
        background: 'linear-gradient(135deg, #38bdf8 0%, #a78bfa 100%)',
        WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
      }}>KnowFi</span>
    </Link>
  );
}
